// Single source of truth for CX.IncomeVerifyType ↔ INCOME_VERIFICATION_TYPES codes
// (utils/quickPricerConstants.js). Encompass values match the legacy wizard's
// incomeDocumentOptions (components/loan-form/create-loan-terms/index.jsx), which is
// what every existing loan already has saved.
export const INCOME_VERIFY_TYPE_FIELD_ID = "CX.IncomeVerifyType";

export const INCOME_VERIFY_TYPE_ENCOMPASS_VALUES = {
	FullDoc: "Full Doc",
	PersonalBankStmt12Mos: "Personal Bank Stmt: 12 Mos",
	PersonalBankStmt24Mos: "Personal Bank Stmt: 24 Mos",
	BusinessBankStmt12Mos: "Business Bank Stmt: 12 Mos",
	BusinessBankStmt24Mos: "Business Bank Stmt: 24 Mos",
	AssetRelated: "Asset Related",
	InvestorDscr: "Investor - DSCR",
	InvestorNoRatio: "Investor - No Ratio",
	PLBankStmt1Yr: "P&L with Bank Statements: 1 Year",
	PLBankStmt2Yr: "P&L with Bank Statements: 2 Year",
	OneYear1099: "One Year 1099",
	TwoYear1099: "Two Year 1099",
};

// Older AURA builds wrote these labels/codes; still accepted on read so those loans
// auto-select instead of showing blank.
const LEGACY_ENCOMPASS_ALIASES = {
	"P&L: 1 Year": "PLBankStmt1Yr",
	"P&L: 2 Year": "PLBankStmt2Yr",
	PLOneYear: "PLBankStmt1Yr",
	PLTwoYear: "PLBankStmt2Yr",
};

const normalize = (value) =>
	String(value ?? "")
		.trim()
		.replace(/\s+/g, " ")
		.toLowerCase();

const REVERSE_LOOKUP = (() => {
	const lookup = {};
	Object.entries(INCOME_VERIFY_TYPE_ENCOMPASS_VALUES).forEach(([code, label]) => {
		lookup[normalize(label)] = code;
		lookup[normalize(code)] = code;
	});
	Object.entries(LEGACY_ENCOMPASS_ALIASES).forEach(([alias, code]) => {
		lookup[normalize(alias)] = code;
	});
	return lookup;
})();

// Option code → Encompass value. Unknown values pass through unchanged.
export const toEncompassIncomeVerifyType = (code) =>
	INCOME_VERIFY_TYPE_ENCOMPASS_VALUES[code] || code;

// Encompass value (or an option code) → option code; undefined when unrecognized.
export const fromEncompassIncomeVerifyType = (value) => {
	if (value === undefined || value === null || value === "") return undefined;
	return REVERSE_LOOKUP[normalize(value)];
};

// Encompass fieldReader responses upper-case `fieldId` (e.g. CX.INCOMEVERIFYTYPE)
// even when requested in mixed case, so field lookups must be case-insensitive.
export const getFieldValue = (fieldsResponse, fieldId) => {
	const target = String(fieldId).toUpperCase();
	return (fieldsResponse || []).find(
		(f) => String(f?.fieldId ?? "").toUpperCase() === target
	)?.value;
};
